import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
  BarChart2,
  MessageSquare,
  Users,
  Trophy,
  ShieldCheck,
  Phone,
  Newspaper,
  Info,
  Settings,
  ChevronDown,
  X,
  Layers,
  Image,
  KeyRound,
  ShieldHalf,
  Award
} from 'lucide-react';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-branding">
        <Link to="/" onClick={() => toggleSidebar && toggleSidebar()}>
          <img src="/img/ITCSF-logo.png" alt="Logo" style={{ height: '42px' }} />
        </Link>
        <button className="mobile-close-btn" onClick={toggleSidebar}>
          <X size={20} />
        </button>
      </div>


      <div className="menu-label">Menu</div>
      <nav>
        <NavLink to="/dashboard" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <BarChart2 className="icon" size={20} />
          <span>Dashboard</span>
        </NavLink>
        <NavLink to="/inqueries" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <MessageSquare className="icon" size={20} />
          <span>Inqueries</span>
        </NavLink>
        <NavLink to="/tournaments" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Trophy className="icon" size={20} />
          <span>Affilated Tournament</span>
        </NavLink>
        <NavLink to="/players" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Users className="icon" size={20} />
          <span>Player List</span>
        </NavLink>
        {/* <NavLink to="/contacts" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Phone className="icon" size={20} />
          <span>Contact List</span>
        </NavLink> */}
        <NavLink to="/news" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Newspaper className="icon" size={20} />
          <span>News & Media</span>
        </NavLink>
        <NavLink to="/about" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Info className="icon" size={20} />
          <span>About ITCSF</span>
        </NavLink>
        <NavLink to="/gallery" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Image className="icon" size={20} />
          <span>Gallery</span>
        </NavLink>
        {/* <NavLink to="/ui-showcase" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Layers className="icon" size={20} />
          <span>UI Components</span>
        </NavLink> */}
      </nav>

      <div className="menu-label">Committee</div>
      <nav>
        <NavLink to="/committee" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <ShieldCheck className="icon" size={20} />
          <span>Committee Members</span>
        </NavLink>
        <NavLink to="/designations" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Award className="icon" size={20} />
          <span>Designations</span>
        </NavLink>
      </nav>

      <div className="menu-label">Access Control</div>
      <nav>
        <NavLink to="/admins" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <Users className="icon" size={20} />
          <span>Admin Users</span>
        </NavLink>
        <NavLink to="/roles" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <ShieldHalf className="icon" size={20} />
          <span>Roles</span>
        </NavLink>
        <NavLink to="/permissions" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <KeyRound className="icon" size={20} />
          <span>Permissions</span>
        </NavLink>
      </nav>

      {/* <div className="menu-label">Manage</div>
      <nav>
        <div className="nav-item">
          <Settings className="icon" size={20} />
          <span>Customization</span>
          <ChevronDown size={16} style={{ marginLeft: 'auto' }} />
        </div>
      </nav> */}
    </div>
  );
};

export default Sidebar;
